<div class="ziti-page-container edge-router-policies-container">
  <lib-list-page-header [title]="title"
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
  (actionClicked)="headerActionClicked($event)"></lib-list-page-header>

  <lib-data-table [tableId]="'edge-router-policies'"
    [rowData]="rowData"
    [columnDefinitions]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [emptyMsg]="'No Edge Router Policies defined, Click the plus to add a Edge Router Policy.'"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    (gridReady)="gridReady($event)"
    >
  </lib-data-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
